import React from 'react'
import { Link } from 'gatsby'

import logoImg from '~img/logos/xcad-mono-gray.svg'

import * as s from './LogoLink.module.scss'

const LogoLink = () => {
  return (
    <Link to="/" title="XCAD Network" aria-label="XCAD Network">
      <img
        src={logoImg}
        alt=" XCAD Network"
        width={100}
        height={48}
        className={s.imgLogo}
      />
    </Link>
  )
}

export default LogoLink
